import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-animated-modal";

class MessageModalPortal extends React.Component {
    constructor(props) {
        super(props);
        if ($('#message-modal').length == 0) {
            $('body').prepend('<div id="message-modal" style="position:absolute; z-index:1501"></div>')
        }
        this.portalRoot = document.getElementById("message-modal");
        this.el = document.createElement("div");
    }
    componentDidMount = () => {
        this.portalRoot.appendChild(this.el);
    };
    componentWillUnmount = () => {
        this.portalRoot.removeChild(this.el);
    };
    onClose = () => {}
    render() {
        const { children } = this.props;
        return ReactDOM.createPortal(children, this.el);
    }
}
class MessageModal extends Component {
    constructor(props) {
        super(props);
    }
    componentWillUnmount = () => {
        this.unmounted = true;
        $(document).unbind('keypress', this.enterKeyListener)
        $(document).unbind('keyup',this.escListener);
    };
    componentDidMount = () => {
        // Set reference to that can be removed at componentWillUnmount
        this.enterKeyListener = (event) => {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                this.props.onClose && this.props.onClose()
            }
        }
        this.escListener = (event) => {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '27'){
                this.props.onClose && this.props.onClose()
            }
        }
        this.unmounted = false
        $(document).keypress(this.enterKeyListener);
        $(document).keyup(this.escListener);
    }
    onClose = () => {}
    render() {
        return (
            <MessageModalPortal>
                <Modal
                    visible={true}
                    closemodal={this.props.onClose}
                    type={this.props.animation || (this.props.isError ? "bounceIn" : "pulse") }>
                    <div className="menu-modal" style={{padding:"20px"}}>
                        <div >
                            {this.props.message}
                        </div>
                        <div style={{textAlign:"right"}}>
                            <button onClick={this.props.onClose} className="btn btn-primary btn-sm">OK</button>
                        </div>
                    </div>
                </Modal>
            </MessageModalPortal>
        )
    }
}
MessageModal.defaultProps = {
    message: "",
    animation: "",

    // isError will show a more catchy animation
    isError: true,
}
export default MessageModal;